<template>
  <a-modal 
    v-model="visible" 
    title="修改职位服务费" 
    :destroyOnClose="true"
    @ok="handleOk"
  >
    <a-form :form="form">
      <h3>招聘服务<span style="color:#FC5646">*</span></h3>
      <!-- <a-form-item label="服务类型" v-bind="formItemsLayout" style="margin-bottom:0;" v-if="type === 'fullTime'">
        <span>{{record.recruit_service_type == 1 ? '面试快' : record.recruit_service_type == 2?'入职快':'过保快'}}</span>
      </a-form-item> -->
      <a-form-item label="服务费" v-bind="formItemsLayout">
        {{ record.service_fee_amount || 0 }}元
      </a-form-item>
      <a-form-item label="猎头分佣" v-bind="formItemsLayout">
        <a-radio-group v-model="hunter_commission_type" :disabled="record.hunter_commission_type>0">
          <a-radio :value="1">按比例计算</a-radio>
          <a-radio :value="2">具体金额</a-radio>
        </a-radio-group>
        <a-input
          :placeholder="hunter_commission_type == 1?'请输入比例':'请输入具体金额'"
          v-decorator="[
            'hunter_commission_value',
            { 
              rules: [{ required: true, message: '请输入佣金比例' }],
              initialValue: hunter_commission_type == 1 ? 100 : hunter_commission_type == 2 ? record.service_fee_amount : '' 
            },
          ]"
          @input="calcCommission"
        >
          <span slot="addonAfter">{{hunter_commission_type == 1?'%':'元'}}</span>
        </a-input>
      </a-form-item>
      <a-form-item label="猎头佣金" v-bind="formItemsLayout">
        {{commission.hunter_commission_amount || 0}}元
      </a-form-item>
      <a-divider style="margin:0 0 5px;" />
      <a-form-item label="平台抽佣" v-bind="formItemsLayout">
        {{commission.platform_commission_rate || 0}}%
      </a-form-item>
      <a-form-item label="抽佣金额" v-bind="formItemsLayout">
        {{commission.platform_commission_amount || 0}}
      </a-form-item>
      <a-divider style="margin:0 0 10px;" />
      <a-form-item label="层级躺赚" v-bind="formItemsLayout">
        <span>平台抽佣额中支出</span>
        <a-input
          style="width:60%;margin-left:10px;"
          placeholder="请输入3级躺赚总额占比"
          @input="calcCommission"
          v-decorator="[ 'layer_rate_value', ]"
        >
          <span slot="addonAfter">{{ hunter_commission_type == 1 ? '%' : '元' }}</span>
        </a-input>
      </a-form-item>
      <a-form-item label="躺赚金额" v-bind="formItemsLayout">
        {{ commission.layer_value || 0}}元
      </a-form-item>
      <h3>悬赏服务<span style="color:#FC5646">*</span></h3>
      <a-form-item label="悬赏金额" v-bind="formItemsLayout">
        {{ record.company_reward_amount || 0 }}元
      </a-form-item>
      <a-form-item label="平台分成" v-bind="formItemsLayout">
        <a-radio-group v-model="platform_reward_commission_type" :disabled="record.platform_reward_commission_type>0">
          <a-radio :value="1">按比例计算</a-radio>
          <a-radio :value="2">具体金额</a-radio>
        </a-radio-group>
        <a-input
          :placeholder="platform_reward_commission_type == 1?'请输入比例':'请输入具体金额'"
          v-decorator="[
            'platform_reward_commission_value',
            { rules: [{ required: true, message: '请输入平台分成' }] }
          ]"
          @input="calcCommission"
        >
          <span slot="addonAfter">{{platform_reward_commission_type == 1?'%':'元'}}</span>
        </a-input>
      </a-form-item>
      <a-form-item label="分成金额" v-bind="formItemsLayout">
        {{ commission.platform_reward_commission_amount || 0 }}元
      </a-form-item>
      <a-form-item label="最终赏金" v-bind="formItemsLayout">
        {{ commission.company_reward_finally_value || 0 }}元
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";

export default {
  name: "serviceFeeModal",
  data() {
    return {
      type: false,
      visible: false,
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      },
      record: {},
      inputPlaceholder: '请输入年薪比例',
      hunter_commission_type: 0,
      platform_reward_commission_type: 0,
      commission: {
        hunter_commission_amount: 0,          //猎头佣金
        platform_commission_rate: 0,          //平台抽佣
        platform_commission_amount: 0,        //抽佣金额
        layer_value: 0,                       //躺赚金额
        platform_reward_commission_amount:0,  //分成金额
        company_reward_finally_value: 0       //最终赏金
      },
    }
  },
  methods: {
    async calcCommission() {
      let formData = this.form.getFieldsValue();
      let params = {
        ...formData,
        job_id: this.record.id,
        company_reward_amount: this.record.company_reward_amount,
        hunter_commission_type: this.hunter_commission_type,
        platform_reward_commission_type: this.platform_reward_commission_type
      }
      if(this.type === 'partTime') {
        params.basic_salary = this.record.flexible_job.basic_salary
        params.basic_salary_period = this.record.flexible_job.basic_salary_period
      }
      let res = await Api.post.calcCommission(params)
      console.log(res);
      this.commission = res
    },
    show(record, type) {
      this.type = type
      this.record = record;
      this.visible = true;
      console.log(record, type);
      this.$nextTick().then(() => {
        this.hunter_commission_type = record.hunter_commission_type
        this.platform_reward_commission_type = record.platform_reward_commission_type
        console.log(record.hunter_commission_type, 'record.hunter_commission_type');
        if(this.hunter_commission_type > 0) {
          this.form.setFieldsValue({
            hunter_commission_value: record.hunter_commission_value,
          })
        } else {
          console.log(record.service_fee_type, 'record.service_fee_type');
          this.hunter_commission_type = Number(record.service_fee_type)
        }
        this.form.setFieldsValue({
          layer_rate_value: record.layer_rate_value,
          platform_reward_commission_value: record.platform_reward_commission_value
        });
        this.calcCommission()
      });
    },
    close() {
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        console.log({
          ...this.commission,
          job_id: this.record.id,
          platform_reward_commission_type: this.platform_reward_commission_type,
          hunter_commission_type: this.hunter_commission_type
        });
        if (!err) {
          this.loading = true;
          try {
            let res = await Api.post.changeServiceFee({
              ...this.commission,
              job_id: this.record.id,
              platform_reward_commission_type: this.platform_reward_commission_type,
              hunter_commission_type: this.hunter_commission_type
            });
            this.$message.success('修改成功');
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    }
  },

};
</script>

<style lang="scss" scoped>
::v-deep .ant-form-item {
  margin-bottom: 5px;
}
</style>
